var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "mb-3" }, [
      _c("label", [
        _vm._v(
          _vm._s(
            _vm.$t(
              "actions.actionDefinition.model.configurationJson.surveySpecific.jobName"
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.name,
            expression: "name"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.name },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.name = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "actions.actionDefinition.model.configurationJson.surveySpecific.survey"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            options: _vm.surveys,
            label: "name",
            reduce: t => t.id,
            clearable: false
          },
          model: {
            value: _vm.surveyId,
            callback: function($$v) {
              _vm.surveyId = $$v
            },
            expression: "surveyId"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("label", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "actions.actionDefinition.model.configurationJson.surveySpecific.board"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("vSelect", {
          attrs: {
            options: _vm.boards,
            label: "name",
            reduce: t => t.id,
            clearable: false
          },
          model: {
            value: _vm.boardId,
            callback: function($$v) {
              _vm.boardId = $$v
            },
            expression: "boardId"
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.boardId !== null
      ? _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("label", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "actions.actionDefinition.model.configurationJson.surveySpecific.flow"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("vSelect", {
              attrs: {
                options: _vm.tickets,
                label: "name",
                reduce: t => t.id,
                clearable: false
              },
              model: {
                value: _vm.ticketId,
                callback: function($$v) {
                  _vm.ticketId = $$v
                },
                expression: "ticketId"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }